module.exports = __webpack_public_path__ + "img/3-hasUnread消息.254f443e.svg";